import React, { useCallback, useState } from 'react';
import AddGif from '@wix/da-ds/pkg/Icons/24x24/AddGif';
import { ButtonProps } from './types';
import GiphyPopup from '../../lego/GiphyPopup';
import { GifObject } from '../../lego/GiphyPopup/types';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';

const Gif: React.FC<ButtonProps> = ({ editor, hideWhenNotEnabled = true }) => {
  const { t } = useTranslation('editor');
  const [showGiphyPopup, setShowGiphyPopup] = useState<boolean>(false);
  const hideGiphyPopup = useCallback(() => {
    setShowGiphyPopup(false);
  }, [setShowGiphyPopup]);

  const onSelect = useCallback(
    (gif: GifObject) => {
      editor
        .chain()
        .focus()
        .daGifAddGif({
          width: gif.width,
          height: gif.height,
          url: gif.originalMp4,
        })
        .run();
    },
    [editor]
  );

  if (!editor.isEditable || (hideWhenNotEnabled && !isExtensionInstalled(editor, 'gif'))) {
    return null;
  }

  return (
    <>
      <EditorIconButton
        featureId="node:gif"
        tooltipText={t('button.gif.tooltip')}
        aria-label={t('button.gif.tooltip')}
        icon={AddGif}
        onClick={() => setShowGiphyPopup(true)}
      />
      {showGiphyPopup && <GiphyPopup onClose={hideGiphyPopup} onSelect={onSelect} />}
    </>
  );
};
Gif.displayName = 'Gif';

export default Gif;
